import { useFormikContext } from 'formik';
import usePrompt from '../../hooks/usePrompt';

const DEFAULT_MESSAGE =
  'You have unsaved changes. Are you sure you want to leave?';

/*
Shows a prompt when the user navigates away from a form when the form is dirty.
For use within the context of a Formik form.
*/
const UnsavedFormPrompt = ({ message = DEFAULT_MESSAGE }) => {
  const { dirty } = useFormikContext();
  usePrompt(message, dirty);
  return null;
};

export default UnsavedFormPrompt;
